<template>
  <div
    class="tab-pane fade show active"
    id="Profile"
    role="tabpanel"
    aria-labelledby="Profile-tab"
  >
    <!--  -->
    <div class="userbox px-20">
      <div>{{userInfoData.email}}</div>
      <div class="userbox_modey">
          <div>
            <div >${{userInfoData.money}}</div>
            <div class="desc">Available Assets</div>
          </div>
      </div>
    </div>
    <div class="box-top">
      <div class="item" @click="handleTabClick('/mine/deposit')">
        <svg class="svg-icon w-34 h-34 mx-8" aria-hidden="true"><use xlink:href="#icon-charge" fill="#333"></use></svg>
          <div>
            <div class="title">Deposit</div>
            <div class="opacity-70">Billing Details>> </div>
          </div>
      </div>
      <div class="item" @click="handleTabClick('/mine/withdraw')">
        <svg class="svg-icon w-34 h-34 mx-8" aria-hidden="true"><use xlink:href="#icon-withdraw" fill="#333"></use></svg>
          <div>
            <div class="title">Withdrawal</div>
            <div class="opacity-70">Billing Details>> </div>
          </div>
      </div>
    </div>
    <!--  -->
    <div class="card">
      <div class="card-body tablist">
        <div v-for="item in tabs" class="tablist-item" :key="item.path"  @click="handleTabClick(item.path)">
          <div class="left">
            <div class="icon" v-html="item.icon"></div>
              <span>{{item.title}}</span>
          </div>

            <svg t="1736999542402" class="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2294" width="64" height="64"><path d="M765.7 486.8L314.9 134.7c-5.3-4.1-12.9-0.4-12.9 6.3v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1c16.4-12.8 16.4-37.6 0-50.4z" p-id="2295" fill="#DCDCDC"></path></svg>
        </div>
      </div>

    </div>
    <!-- <div class="card">
      <div class="card-body">
        <h5 class="card-title">General Information</h5>
        <div class="settings-profile">
          <form>

            <div class="row mt-4">
              <div class="col-md-6">
                <label htmlFor="formFirst">Nickname</label>
                <input
                  id="formFirst"
                  type="text"
                  class="form-control"
                  placeholder="Nickname"
                  v-model="nickname"
                />
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="updateNickname">Update</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div> -->
    <!-- <div class="card">
      <div class="card-body">
        <h5 class="card-title">Set withdrawal password</h5>
        <div class="settings-profile">
          <form>
            <div class="row">
              <div class="col-md-6">
                <label htmlFor="currentPass"> Current password </label>
                <input
                  id="currentPass"
                  type="password"
                  class="form-control"
                  placeholder="Enter your password"
                  v-model="currentPayPassword"
                />
              </div>
              <div class="col-md-6">
                <label htmlFor="newPass">New password</label>
                <input
                  id="newPass"
                  type="password"
                  class="form-control"
                  placeholder="Enter new password"
                  v-model="newPayPassword"
                />
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="setPayPwd">Update</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Changing Login Password</h5>
        <div class="settings-profile">
          <form>
            <div class="row">
              <div class="col-md-6">
                <label htmlFor="currentPass1"> Current password </label>
                <input
                  id="currentPass1"
                  type="password"
                  class="form-control"
                  placeholder="Enter your password"
                  v-model="currentPassword"
                />
              </div>
              <div class="col-md-6">
                <label htmlFor="newPass1">New password</label>
                <input
                  id="newPass1"
                  type="password"
                  class="form-control"
                  placeholder="Enter new password"
                  v-model="newPassword"
                />
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="changePwd">Update</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <button class="btn btn-danger" @click="logout">Logout</button> -->
  </div>
</template>

<script>
import { updateNickname, changePwd, setPayPwd } from "@/apis/user";
import { message } from "@/utils/message";
export default {
  data() {
    return {
      nickname: "",
      currentPassword: "",
      newPassword: "",
      currentPayPassword: "",
      newPayPassword: "",
      userInfoData: {},
      tabs: [
        {
          title: "PROFILE",
          path: "/mine/userPwd",
          icon: '<svg class="svg-icon w-20 h-20" aria-hidden="true"><use xlink:href="#icon-real-auth" fill="#333"></use></svg>'
        },
        {
          title: "WALLET",
          path: "/mine/wallet",
          icon: '<svg t="1737002246799" class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3377" width="64" height="64"><path d="M0 204.8c0-56.32 46.08-102.4 102.4-102.4h768a51.2 51.2 0 0 1 51.2 51.2v51.2H102.4v51.2h870.4a51.2 51.2 0 0 1 51.2 51.2v512a102.4 102.4 0 0 1-102.4 102.4H102.4a102.4 102.4 0 0 1-102.4-102.4V204.8z m844.8 460.8a76.8 76.8 0 1 0 0-153.6 76.8 76.8 0 0 0 0 153.6z" p-id="3378" fill="#0166FC"></path></svg>'
        },
        // {
        //   title: "DEPOSIT",
        //   path: "/mine/deposit",
        // },
        // {
        //   title: "WITHDRAW",
        //   path: "/mine/withdraw",
        // },

        {
          title: "ACCOUNT RECORDS",
          path: "/mine/account-records",
          icon: '<svg t="1737002586887" class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6163" width="64" height="64"><path d="M723.43 508.6c-54.123 47.75-125.977 77.056-205.163 77.056-80.364 0-153.4-30.259-207.765-79.421C184.05 539.325 105.81 652.308 105.81 787.277v68.782c0 160.968 812.39 160.968 812.39 0v-68.782c-0.005-131.415-74.22-242.509-194.77-278.677z m-205.163 28.13c140.165 0 254.095-109.44 254.095-244.64S658.668 47.218 518.267 47.218c-139.93 0-253.855 109.675-253.855 244.874 0 135.204 113.925 244.639 253.855 244.639z m0 0" p-id="6164" fill="#0166FC"></path></svg>'
        },
        // {
        //   title: "TRADING RECORDS",
        //   path: "/mine/trading-records",
        //   icon: '<svg t="1737002641765" class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7278" width="64" height="64"><path d="M474.752 767.36H554.24a22.4 22.4 0 0 0 22.592-22.144v-38.464c58.432-16.704 92.672-56.768 92.672-109.696 0-99.2-99.072-124.672-141.312-135.616-62.72-15.744-62.72-28.16-62.72-34.112 0-19.264 26.368-26.048 48.96-26.048 38.784 0 42.88 16.576 43.648 33.536a22.4 22.4 0 0 0 22.528 21.056h59.648a22.4 22.4 0 0 0 22.592-22.144 22.08 22.08 0 0 0-1.664-8.256c-4.48-49.856-35.968-89.344-84.48-107.072v-40.512a22.336 22.336 0 0 0-22.592-22.144H474.688a22.336 22.336 0 0 0-22.528 22.144v39.168c-57.664 18.048-92.736 59.2-92.736 110.72 0 95.296 106.688 120.448 141.824 128.768 62.208 14.592 62.208 32.576 62.208 41.216 0 15.104-18.24 24.192-48.96 24.192-53.312 0-55.616-24.96-56.448-34.432a22.592 22.592 0 0 0-22.528-20.224h-58.368a22.656 22.656 0 0 0-16.384 6.912 21.248 21.248 0 0 0-6.144 16.512c3.2 55.04 39.232 97.152 97.536 115.2v39.36a22.4 22.4 0 0 0 22.592 22.08zM55.488 445.312a65.6 65.6 0 0 0 81.152-43.072C185.664 240.768 340.032 128 512 128c117.696 0 227.2 52.864 300.224 137.984l-16.576-6.016a65.664 65.664 0 0 0-83.84 37.824 63.744 63.744 0 0 0 38.592 82.24l176.832 64.064a65.92 65.92 0 0 0 67.2-13.376 63.168 63.168 0 0 0 17.92-64.96C947.136 150.464 741.312 0 512 0 282.688 0 76.864 150.4 11.584 365.76a63.744 63.744 0 0 0 43.904 79.552z m913.024 133.376a65.344 65.344 0 0 0-81.152 43.072C838.4 783.232 684.032 896 512 896c-117.76 0-227.2-52.864-300.288-137.984l16.64 6.08a65.728 65.728 0 0 0 83.84-37.888 63.68 63.68 0 0 0-38.656-82.24L96.64 579.904a66.24 66.24 0 0 0-67.2 13.376 63.296 63.296 0 0 0-17.92 64.96C76.864 873.536 282.688 1024 512 1024s435.072-150.336 500.416-365.76a63.68 63.68 0 0 0-43.904-79.552z" fill="#0166FC" p-id="7279"></path></svg>'
        // },
        {
          title: "WALLET ADDRESS",
          path: "/mine/wallet-address",
          icon: '<svg t="1737003120887" class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11805" width="64" height="64"><path d="M85.333333 384h810.666667a42.666667 42.666667 0 0 1 42.666667 42.666667v426.666666a42.666667 42.666667 0 0 1-42.666667 42.666667H128a42.666667 42.666667 0 0 1-42.666667-42.666667V384z m42.666667-256h640v170.666667H85.333333V170.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z m512 469.333333v85.333334h128v-85.333334h-128z" p-id="11806" fill="#0166FC"></path></svg>'
        },
      ],
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    handleTabClick(path) {
      this.$router.push(path);
    },
    async getUserInfo() {
      await this.$store.dispatch("getUserInfo");
      if (this.$store.state.userInfo) {
        // console.log(this.$store.state.userInfo, '-----')
        this.userInfoData = this.$store.state.userInfo
        this.nickname = this.$store.state.userInfo.nickname;
      }
    },
    updateNickname() {
      if (!this.nickname) {
        message.error("Nickname cannot be empty");
      }
      updateNickname({ nickname: this.nickname }).then((res) => {
        if (res.code === 0) {
          message.success("Nickname updated successfully");
          this.getUserInfo();
        }
      });
    },
    changePwd() {
      changePwd({ pwd: this.currentPassword, new_pwd: this.newPassword }).then((res) => {
        if (res.code === 0) {
          message.success("Password updated successfully");
          this.currentPassword = "";
          this.newPassword = "";
        }
      });
    },
    setPayPwd() {
      setPayPwd({ old_pwd: this.currentPayPassword, pay_pwd: this.newPayPassword }).then((res) => {
        if (res.code === 0) {
          message.success("Withdrawal password updated successfully");
          this.currentPayPassword = "";
          this.newPayPassword = "";
        }
      });
    },
    logout() {
      this.$store.dispatch("clearLoginData");
      this.$router.push("/login");
    },
  },
};
</script>
<style>
  .svg-icon {
    width: 5.33333vw;
    height: 5.33333vw;
  }
</style>
<style scoped lang="scss">
  .userbox {

    height: 49.6vw;
    background: linear-gradient(90deg,#207aff,#015feb);
    color: #fff;
    padding-left: 5.33333vw ;
    padding-right: 5.33333vw ;
    padding-top: 6.93333vw ;
    font-size: 5.33333vw ;
    font-weight: 700;
    .userbox_modey {
      margin-top: 5.33333vw;
      .desc {
        font-size: 3.2vw;
      }
    }
  }
  .tablist {
    &-item {
      .icon {
        background-color: rgb(220,234,255);
        padding: 1.6vw;
        border-radius: 2.66667vw;
        margin-right: 2.66667vw;
        .svg-icon {
          width: 5.33333vw;
          height: 5.33333vw;
        }
      }
      .left {
        display: flex;
        align-items: center;
      }
      margin-top: 2.66667vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      padding: 8px 12px;
        box-shadow: 0 0 6.4vw rgba(161, 161, 161, .09);
        justify-content: space-between;
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
.box-top {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 2.66667vw;
  .item {
    background-color: #0166fc;
    color: #fff;
    display: flex;
    width: 42%;
    font-size: 3.2vw;
    height: 13.86667vw;
    align-items: center;
    border-radius: 4.26667vw;
    justify-content: space-evenly;
    .title {
      font-weight: 600;
    }
    .opacity-70 {
      opacity: .7;
    }
    &:nth-child(2) {
      background-color: #f23c48;
    }
    svg {
      width: 9.06667vw;
      height: 9.06667vw;

    }
  }
}
</style>
